const tableCustomStyles = {
    table: {
      style: {
        marginTop: '10px'
      }
    },
    headRow: {
      style: {
        fontSize: '12px',
        color: '#FFF',
        fontWeight: 'bold',
        backgroundColor: '#12708C',
        borderRadius: '5px 5px 0px 0px',
      },
    },
    rows: {
      style: {
        height: '40px',
        fontSize: '12px',
      }
    },
    pagination: {
      style: {
        borderRadius: '0px 0px 5px 5px'
      }
    }
  }

export { tableCustomStyles };


const userTableCustomStyles = {
  table: {
    style: {
      marginTop: '10px',
    }
  },
  headRow: {
    style: {
      fontSize: '12px',
      color: '#FFF',
      fontWeight: 'bold',
      backgroundColor: '#12708C',
      borderRadius: '5px 5px 0px 0px',
    },
  },
  rows: {
    style: {
      height: '65px',
      fontSize: '12px',
    }
  },
  pagination: {
    style: {
      borderRadius: '0px 0px 5px 5px'
    }
  }
}

export { userTableCustomStyles };


const containerSummaryDetailTableCustomStyles = {
  table: {
    style: {
      marginTop: '10px'
    }
  },
  headRow: {
    style: {
      fontSize: '12px',
      color: '#000',
      fontWeight: 'bold',
      backgroundColor: '#E0E0E0'
    },
  },
  rows: {
    style: {
      height: '65px',
      fontSize: '12px',
    }
  },
  pagination: {
    style: {
      borderRadius: '0px 0px 5px 5px'
    }
  }
}

export { containerSummaryDetailTableCustomStyles };



const shipmentContainerTableCustomStyles = {
  table: {
    style: {
      marginTop: '10px'
    }
  },
  headRow: {
    style: {
      fontSize: '12px',
      borderRadius: '5px 5px 0px 0px',
      color: '#FFF',
      fontWeight: 'bold',
      backgroundColor: '#12708C'
    },
  },
  rows: {
    style: {
      height: '165px',
      fontSize: '12px',
    }
  },
  pagination: {
    style: {
      borderRadius: '0px 0px 5px 5px'
    }
  }
}

export { shipmentContainerTableCustomStyles };


const containerTableCustomStyles = {
  // table: {
  //   style: {
  //     marginTop: '10px'
  //   }
  // },
  headRow: {
    style: {
      fontSize: '12px',
      color: '#FFF',
      fontWeight: 'bold',
      backgroundColor: '#12708C',
      borderRadius: '5px 5px 0px 0px',
      paddingTop: '10px',
      paddingBottom: '10px',
    },
  },
  rows: {
    style: {
      height: '65px',
      fontSize: '12px',
    }
  },
  pagination: {
    style: {
      borderRadius: '0px 0px 5px 5px'
    }
  }
}

export { containerTableCustomStyles };



const tariffTableCustomStyles = {
  table: {
    style: {
      marginTop: '10px'
    }
  },
  headRow: {
    style: {
      fontSize: '12px',
      color: '#FFF',
      fontWeight: 'bold',
      backgroundColor: '#12708C',
      borderRadius: '5px 5px 0px 0px',
    },
  },
  rows: {
    style: {
      height: '200px',
      fontSize: '12px',
    }
  },
  pagination: {
    style: {
      borderRadius: '0px 0px 5px 5px'
    }
  }
}

export { tariffTableCustomStyles };


const tariffChargeTableCustomStyles = {
  table: {
    style: {
      marginTop: '10px'
    }
  },
  headRow: {
    style: {
      fontSize: '12px',
      color: '#FFF',
      fontWeight: 'bold',
      backgroundColor: '#12708C',
      borderRadius: '5px 5px 0px 0px',
    },
  },
  rows: {
    style: {
      height: '120px',
      fontSize: '12px',
    }
  },
  pagination: {
    style: {
      borderRadius: '0px 0px 5px 5px'
    }
  }
}

export { tariffChargeTableCustomStyles };


const tariffChargeBulkTableCustomStyles = {
  table: {
    style: {
      marginTop: '10px'
    }
  },
  headRow: {
    style: {
      fontSize: '12px',
      color: '#FFF',
      fontWeight: 'bold',
      backgroundColor: '#12708C',
      borderRadius: '5px 5px 0px 0px',
    },
  },
  rows: {
    style: {
      height: '120px',
      fontSize: '12px',
    }
  },
  pagination: {
    style: {
      borderRadius: '0px 0px 5px 5px'
    }
  }
}

export { tariffChargeBulkTableCustomStyles };


const tariffChargeBulkConditionalRowCustomStyles = [
  {
    when: row => row.exist == true,
    style: {
      backgroundColor: '#FFEBEE',
      color: '#B71C1C',
    },
  },
  {
    when: row => row.active === false,
    style: {
      backgroundColor: '#FFEBEE',
      color: '#B71C1C',
    },
  },
]

export { tariffChargeBulkConditionalRowCustomStyles };





const shipmentTableCustomStyles = {
  table: {
    style: {
      marginTop: '10px'
    }
  },
  headRow: {
    style: {
      fontSize: '12px',
      color: '#FFF',
      fontWeight: 'bold',
      backgroundColor: '#12708C',
      paddingTop: '10px',
      paddingBottom: '10px',
    },
  },
  rows: {
    style: {
      height: '270px',
      fontSize: '12px',
    }
  },
  pagination: {
    style: {
      borderRadius: '0px 0px 5px 5px'
    }
  }
}

export { shipmentTableCustomStyles };


const shipmentUploadsTableCustomStyles = {
  table: {
    style: {
      marginTop: '10px'
    }
  },
  headRow: {
    style: {
      fontSize: '12px',
      color: '#FFF',
      fontWeight: 'bold',
      backgroundColor: '#12708C',
      borderRadius: '5px 5px 0px 0px',
    },
  },
  rows: {
    style: {
      height: '160px',
      fontSize: '12px',
    }
  },
  pagination: {
    style: {
      borderRadius: '0px 0px 5px 5px'
    }
  }
}

export { shipmentUploadsTableCustomStyles };



const importExportTableCustomStyles = {
  table: {
    style: {
      marginTop: '10px'
    }
  },
  headRow: {
    style: {
      fontSize: '12px',
      color: '#FFF',
      fontWeight: 'bold',
      backgroundColor: '#12708C',
      borderRadius: '5px 5px 0px 0px',
    },
  },
  rows: {
    style: {
      height: '50px',
      fontSize: '12px',
    }
  },
  pagination: {
    style: {
      borderRadius: '0px 0px 5px 5px'
    }
  }
}

export { importExportTableCustomStyles };


const hazardousDataTableCustomStyles = {
  table: {
    style: {
      marginTop: '10px'
    }
  },
  headRow: {
    style: {
      fontSize: '12px',
      color: '#FFF',
      fontWeight: 'bold',
      backgroundColor: '#12708C',
      borderRadius: '5px 5px 0px 0px',
    },
  },
  rows: {
    style: {
      height: '50px',
      fontSize: '12px',
    }
  },
  pagination: {
    style: {
      borderRadius: '0px 0px 5px 5px'
    }
  }
}

export { hazardousDataTableCustomStyles };


const vesselScheduleTableCustomStyles = {
  table: {
    style: {
      marginTop: '10px'
    }
  },
  headRow: {
    style: {
      fontSize: '12px',
      color: '#FFF',
      fontWeight: 'bold',
      backgroundColor: '#12708C',
      borderRadius: '5px 5px 0px 0px',
    },
  },
  rows: {
    style: {
      height: '80px',
      fontSize: '12px',
    }
  },
  pagination: {
    style: {
      borderRadius: '0px 0px 5px 5px'
    }
  }
}

export { vesselScheduleTableCustomStyles };


const terminalTableCustomStyles = {
  table: {
    style: {
      marginTop: '10px',
      overflowX: 'hidden'
    }
  },
  headRow: {
    style: {
      fontSize: '12px',
      color: '#FFF',
      fontWeight: 'bold',
      backgroundColor: '#12708C',
      borderRadius: '5px 5px 0px 0px',
    },
  },
  rows: {
    style: {
      height: '65px',
      fontSize: '12px',
    }
  },
  pagination: {
    style: {
      borderRadius: '0px 0px 5px 5px'
    }
  }
}

export { terminalTableCustomStyles };



const blTableCustomStyles = {
  table: {
    style: {
      marginTop: '10px',
      overflowX: 'hidden'
    }
  },
  headRow: {
    style: {
      fontSize: '12px',
      color: '#FFF',
      fontWeight: 'bold',
      backgroundColor: '#12708C',
      borderRadius: '5px 5px 0px 0px',
    },
  },
  rows: {
    style: {
      height: '85px',
      fontSize: '12px',
    }
  },
  pagination: {
    style: {
      borderRadius: '0px 0px 5px 5px'
    }
  }
}

export { blTableCustomStyles };


const shipmentUploadTableCustomStyles = {
  table: {
    style: {
      marginTop: '10px',
    }
  },
  headRow: {
    style: {
      fontSize: '12px',
      color: '#FFF',
      fontWeight: 'bold',
      backgroundColor: '#12708C',
      borderRadius: '5px 5px 0px 0px',
    },
  },
  rows: {
    style: {
      height: '200px',
      fontSize: '12px',
    }
  },
  pagination: {
    style: {
      borderRadius: '0px 0px 5px 5px'
    }
  }
}

export { shipmentUploadTableCustomStyles };



const vesselWiseBookingCustomStyles = {
  table: {
    style: {
      marginTop: '10px',
    }
  },
  headRow: {
    style: {
      fontSize: '12px',
      color: '#FFF',
      fontWeight: 'bold',
      backgroundColor: '#12708C',
    },
  },
  rows: {
    style: {
      height: '65px',
      fontSize: '12px',
    }
  },
  pagination: {
    style: {
      borderRadius: '0px 0px 5px 5px'
    }
  }
}

export { vesselWiseBookingCustomStyles };